import { SummaryTile } from '@/components'
import { routes } from '@/router'
import { SwapVert } from '@mui/icons-material'
import { useMediaQuery, Theme, Card, Typography } from '@mui/material'

export function MonthlyDocuments() {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))

  if (isMobile) {
    return (
      <SummaryTile
        to={routes.accounting.monthlyDocuments}
        icon={<SwapVert />}
        label={
          <>
            Movimento <br /> mensal
          </>
        }
      />
    )
  }

  return (
    <Card>
      <Typography fontSize={20} mb={2}>
        Movimento mensal
      </Typography>

      <Typography color="textDisabled" py={3} textAlign="center">
        Você não possui pendências
      </Typography>
    </Card>
  )
}
